export enum MoveContent {
  Boxes = 'boxes',
  Furniture = 'furniture',
  ApplianceAndMore = 'applianceAndMore',
}

export enum QuoteConstraint {
  unavailableDate = 'unavailableDate',
  unavailablePreferredTime = 'unavailablePreferredTime',
  notEnoughTrucks = 'notEnoughTrucks',
  doesNotOfferedSingleManService = 'doesNotOfferedSingleManService',
  additionalServicesNotOffered = 'additionalServicesNotOffered',
  overnightNotOffered = 'overnightNotOffered',
  specialServicesNotOffered = 'specialServicesNotOffered',
  specialItemsNotSupported = 'specialItemsNotSupported',
  protectiveMaterialNotOffered = 'protectiveMaterialNotOffered',
}
